import { z } from 'zod';

/** Tugas yang boleh dipanggil. Ditambah seiring fitur AI baru dibangun. */
export const aiTaskSchema = z.enum([
  'ping',
  'brief-parse',
  'product-description',
  'product-split',
  'image-tag',
  'article-draft',
  'support-reply',
  'search-rerank',
  'assistant-web',
  'assistant-admin',
]);
export type AiTask = z.infer<typeof aiTaskSchema>;

/** fast = model murah untuk tugas ringan, smart = model utama untuk penalaran. */
export const aiTierSchema = z.enum(['fast', 'smart']);
export type AiTier = z.infer<typeof aiTierSchema>;

export const aiPingSchema = z.object({
  prompt: z.string().min(1).max(4000),
  tier: aiTierSchema.default('fast'),
});
export type AiPingInput = z.infer<typeof aiPingSchema>;

export const aiUsageQuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(90).default(7),
});
export type AiUsageQuery = z.infer<typeof aiUsageQuerySchema>;
